import vuetify from './plugins/vuetify';
import Vue from 'vue';
import VueRouter from 'vue-router';

import App from './App';
import { routes } from './routes';
import { store} from './store/store'
import { i18n } from "./translations/i18n";
import './shared/outside-click-directive'

const enEnabled = document.getElementById('_yjastuksammioweb_' + 'app_attrs').getAttribute('data-use-en') === 'true';

AUI().use('liferay-portlet-url')

Vue.use(VueRouter);

export const router = new VueRouter({
	//mode: 'history',
	routes
});

router.beforeEach((to, from, next) => {

	// Check for used language and set html lang-parameter based on it
	if (i18n.locale === 'fi') {
		document.documentElement.setAttribute("lang","fi");
	} else {
		if (to.query.hasOwnProperty('lang')) {
			document.documentElement.setAttribute("lang", to.query.lang);
		}
	}

	var pageName = to.name;
	var siteName = i18n.t('sammio.site.name_short');

	// Check if translation (object or string) exists
	if (i18n.te('sammio.' + to.name)) {

		// Check if title is defined
		if (i18n.te('sammio.' + to.name + '.title')) {
			pageName = i18n.t('sammio.' + to.name + '.title');
		} else {
			pageName = i18n.t('sammio.' + to.name);
		}
	}

	Vue.nextTick(() => {
		// Set page title name
		document.title = pageName + ' - ' + siteName;

		// Update aria-live element text, propmting screen readers to say it 
		jQuery('#announcer').text(pageName + ' - ' + siteName);

		// If full page change has happened, focus html element
		if (to.params.page_change === 'full') {
			jQuery('html').focus();
		}
	})

	if (i18n.locale !== 'fi') {
		if (!to.query.hasOwnProperty('lang') && (from.query.hasOwnProperty('lang'))) {
			return next({name: to.name, query: from.query})
		} else {
			return next()
		}
	} else {
		next()
	}
})

// Prevent excess logging due to Vue bug (https://github.com/vuejs/vue/issues/10939), still open at least on Vue version 2.6.11
// the warning is produced by using vue-feather-icons with Vuetify
const ignoredMessage = "The .native modifier for v-on is only valid on components but it was used on <svg>.";
Vue.config.warnHandler = (message, vm, componentTrace) => {
	if (message !== ignoredMessage) {
		console.error(message + componentTrace);
	}
};

new Vue({
	i18n,
	router,
	vuetify,
	store,
	el: '#_yjastuksammioweb_app',
	render: h => h(App),
	data() {
		return {
			portletId: 'yjastuksammioweb',
			enEnabled: enEnabled
		}
	}
});
